import React from 'react';
import './index.scss';

// import InputIcon from 'assets/PC_icon_01.png';
// import ConfIcon from 'assets/PC_icon_02.png';
// import ThanksIcon from 'assets/PC_icon_03.png';
// import AddInputIcon from 'assets/PC_icon_04.png';
// import AddConfIcon from 'assets/PC_icon_05.png';
// import AddThanksIcon from 'assets/PC_icon_06.png';

import { INPUT_URL, CONF_URL, THANKS_URL, ADD_INPUT_URL, ADD_CONF_URL, ADD_THANKS_URL } from 'utils/constant';

const dir = require.context('assets/');
const InputIcon = dir(`./PC_icon_01.png`);
const ConfIcon = dir(`./PC_icon_02.png`);
const ThanksIcon = dir(`./PC_icon_03.png`);
const AddInputIcon = dir(`./PC_icon_04.png`);
const AddConfIcon = dir(`./PC_icon_05.png`);
const AddThanksIcon = dir(`./PC_icon_06.png`);

const PcProgress = ({ path })=>{

  const PcProgressImage = ({ img }) => (
    <div className="img-area">
      <img className="img" src={img} alt={img} />
    </div>
  );
  const ProgressPattern = {
    [INPUT_URL]: <PcProgressImage img={InputIcon} />,
    [CONF_URL]: <PcProgressImage img={ConfIcon} />,
    [THANKS_URL]: <PcProgressImage img={ThanksIcon} />,
    [ADD_INPUT_URL]: <PcProgressImage img={AddInputIcon} />,
    [ADD_CONF_URL]: <PcProgressImage img={AddConfIcon} />,
    [ADD_THANKS_URL]: <PcProgressImage img={AddThanksIcon} />,
  };
  return(
    <div className="PcProgress" id="PcProgress">
      <div className="pc-progress-wrapper">
        {ProgressPattern[path]}
      </div>
    </div>
  );
};

export default PcProgress;